
import Box from '@mui/material/Box';
import { MenuProvider } from '../../contexts/menu/MenuProvider';
import { MainRoutes } from '../../routes';
import { AppBarMenu, DrawerMenu, MyMainContent } from './components';

export const Layout = () => {
  return (
    <MenuProvider>
      <Box sx={{ display: 'flex' }}>
        <AppBarMenu />
        <DrawerMenu />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode,
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <MyMainContent>
            <MainRoutes />
          </MyMainContent>
        </Box>
      </Box>
    </MenuProvider >
  );
}
